import Page from "../shared/ui/components/Page";
import SmartForm from "../widgets/SmartForm";

export default function CreateWorkflow() {
  return <Page title="Create Workflow" content={<SmartForm />} />;
}
